























































































































import LoadingIcon from '@/components/icons/LoadingIcon.vue';
import TbTrashXIcon from '@/components/icons/TbTrashXIcon.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import trackClick, { BTN_EVTS } from '@/directives/trackClick';

export interface Button {
  name: string,
  id: string,
  className?: string,
  isActive: Boolean,
  appendIcon?: any,
  disabled?: boolean,
}

@Component({ components: { LoadingIcon, TbTrashXIcon }, directives: { trackClick } })
export class BottomWrapper extends Vue {
  @Prop({ default: () => [] }) readonly buttons!: Button [];
  @Prop({ default: () => ({
    isErr: false,
    message: '',
  }) }) readonly errInfo!: {isErr: boolean, message: string}
  close = false;
  @Prop(Boolean) readonly isFixed!: boolean;
  @Prop(Boolean) readonly showBack!: boolean;
  @Prop(Boolean) readonly showLoading!: boolean;
  @Prop(String) readonly loadingText!: string;
  @Prop(Boolean) readonly cancelableRequest!: boolean;

  readonly BTN_EVTS = BTN_EVTS;

  showCancelRequestConfirmation=false;

  get errorMsg () {
    if (!this.errInfo.isErr) return '';
    return this.errInfo.message ? this.errInfo.message : this.$t('page.bottom_wrapper.tech_issue');
  }

  toggle () {
    this.close = !this.close;
  }
  handleClick (button: Button) {
    this.$emit('select', button);
  }
  retry () {
    this.$emit('retry');
  }

  toggleCancelRequestPrompt () {
    this.showCancelRequestConfirmation = !this.showCancelRequestConfirmation;
    if (this.showCancelRequestConfirmation && this.close) {
      this.toggle();
    }
  }

  @Watch('cancelableRequest')
  resetCancelConfirmation () {
    if (!this.cancelableRequest) { this.showCancelRequestConfirmation = false; }
  }
}

export default BottomWrapper;
